import React from "react";
import LinkNavbar from "../components/linksnavbar/LinkNavbar";
import Hero from "../components/hero/Hero";
import Trendingreviews from "../components/trendingreviews/Trendingreviews";
import Ratemymanagerworks from "../components/ratemymanagerworks/Ratemymanagerworks";
import Getupdates from "../components/getupdates/Getupdates";
import Latestnewssection from "../components/latestnews/Latestnewssection";
import Topratedcompanies from "../components/topratedcompaniessection/Topratedcompanies";
import CreateCompanyFooter from "../components/createcompanyfooter/CreateCompanyFooter";
import TrustStatistics from "../components/trustStatistics/TrustStatistics";
import CompareManagers from "../components/CompareManagers/CompareManagers";

const HomePage = () => {
  return (
    <div>
      <Ratemymanagerworks />
      <Topratedcompanies />
      <TrustStatistics />
      <CompareManagers />
      <Getupdates />
      <CreateCompanyFooter />
    </div>
  );
};

export default HomePage;
